export var LoyaltyRewardsMarkId = {
  ORBITZ_REWARDS_MARK_ID: 'loyalty',
  EPS_REWARDS_MARK_ID: 'rewards_orb',
  HAWAIIAN_REWARDS_MARK_ID: 'hawaiian'
};
// UitkHeadingTag only support till h6
export var EgdsHeadingTagStyle;
(function (EgdsHeadingTagStyle) {
  EgdsHeadingTagStyle["H1"] = "h1";
  EgdsHeadingTagStyle["H2"] = "h2";
  EgdsHeadingTagStyle["H3"] = "h3";
  EgdsHeadingTagStyle["H4"] = "h4";
  EgdsHeadingTagStyle["H5"] = "h5";
  EgdsHeadingTagStyle["H6"] = "h6";
  EgdsHeadingTagStyle["H7"] = "h6";
  EgdsHeadingTagStyle["H8"] = "h6";
})(EgdsHeadingTagStyle || (EgdsHeadingTagStyle = {}));
export var TextTheme;
(function (TextTheme) {
  TextTheme["EMPHASIS"] = "emphasis";
  TextTheme["INVERSE"] = "inverse";
  TextTheme["POSITIVE"] = "positive";
  TextTheme["NEGATIVE"] = "negative";
  TextTheme["PRIMARY"] = "default";
  TextTheme["SECONDARY"] = "default";
  TextTheme["LOYALTY"] = "loyalty";
})(TextTheme || (TextTheme = {}));
export var TextWeight;
(function (TextWeight) {
  TextWeight["BOLD"] = "bold";
  TextWeight["MEDIUM"] = "medium";
  TextWeight["REGULAR"] = "regular";
})(TextWeight || (TextWeight = {}));
// ActivityBadgeTheme for image badges
export var ActivityBadgeTheme;
(function (ActivityBadgeTheme) {
  ActivityBadgeTheme["DEAL_GENERIC"] = "DEAL_GENERIC";
  ActivityBadgeTheme["DEAL_MEMBER"] = "DEAL_MEMBER";
  ActivityBadgeTheme["DEAL_BUNDLED"] = "DEAL_BUNDLED";
  ActivityBadgeTheme["GLOBAL_LOW_TIER"] = "GLOBAL_LOW_TIER";
})(ActivityBadgeTheme || (ActivityBadgeTheme = {}));
export var UITK_HEADING_SIZE = 5;
export var UITK_HEADING_SIZE_ACTIVITY = 7;
export var VERTICAL_LAYOUT_TRUE = 1;
export var VERTICAL_LAYOUT_FALSE = 3;
export var ACTIVITY_DETAILS_BATCHING = 'activity-details-batching';